import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

export const CheckDateField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRefund } = useAppSelector(state => state.refund);

  // Check if the field should be editable (only when status is AP)
  const isEditable = currentRefund?.status === 'AP';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isEditable) return;
    dispatch(updateCheckInfo({ checkDate: event.target.value }));
  };

  // Format date for display
  const formatDateForInput = (dateString?: string | null): string => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0]; // YYYY-MM-DD format
    } catch {
      return '';
    }
  };

  return (
    <TextField
      label="Check Date"
      type="date"
      value={formatDateForInput(currentRefund?.checkInfo?.checkDate)}
      onChange={handleChange}
      size="small"
      fullWidth
      required={isEditable}
      disabled={!isEditable}
      InputLabelProps={{
        shrink: true,
      }}
      placeholder={isEditable ? "Select check date" : "Not available"}
    />
  );
};

export default CheckDateField;
